// extracted by mini-css-extract-plugin
module.exports = {"block":"plan-catalog-preview-skeleton_block__mMz9h","fill":"plan-catalog-preview-skeleton_fill__STNd4"};